// extracted by mini-css-extract-plugin
export default {"NoFavorites":"styles_NoFavorites__kng8K","text":"styles_text__2ZeMV","star":"styles_star__RWOeb","icons":"styles_icons__d+0m6"};